// extracted by mini-css-extract-plugin
export default {"container":"style_container__Wwy+I","fullWidth":"style_fullWidth__y1Fu8"};